<template>
  <div class="profiles-list">
    <ProfileCard
      v-for="card in props.cards"
      :card="card"
      :key="card.id"
    />
  </div>
</template>

<script setup lang="ts">
import ProfileCard from "@/common/ProfileCard.vue";
import {PropType} from "vue";
import ProfileCardInterface from "@/common/types/ProfileCardInterface";

const props = defineProps({
  cards: {
    type: Array as PropType<Array<ProfileCardInterface>>,
    required: true,
  },
})
</script>

<style scoped>
.profiles-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  padding: 0 16px 16px;
  overflow-y: auto;
  max-height: 500px;

  ::v-deep(.profile-card__photo) {
    height: 215px;
  }
}
</style>